import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { SecurityGuard } from './security.guard';
import { SecurityService } from './security.service';
import { RefreshInterceptor } from './refresh.interceptor';
import { SecurityInterceptor } from './security.interceptor';

@NgModule({
  imports: [RouterModule],
})
export class SecurityModule {
  public static forRoot(): ModuleWithProviders<SecurityModule> {
    return {
      ngModule: SecurityModule,
      providers: [
        SecurityGuard,
        SecurityService,
        SecurityInterceptor,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: RefreshInterceptor,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useExisting: SecurityInterceptor,
          multi: true,
        },
      ],
    };
  }
}
